export default ".icon{font-size:14px}h4.title{margin:0}";